import { SET_CONTACT } from "./actionsType";

export const setVerifyAccountContact = (contact, type) => {
  return {
    type: SET_CONTACT,
    contact: contact,
    contactType: type,
  };
};
